module.exports = __webpack_public_path__ + "static/media/4yeast.b9b5a48e.jpg";